import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TabsOverflowMenuDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    hidden: {
        pointerEvents: "none",
        position: "absolute",
        opacity: 0,
        ...webStyle({
            visibility: "hidden"
        })
    },
    container: {
        flexShrink: 0
    }
});

export const useStyles = ({
    gap
}: TabsOverflowMenuDynamicStyleType) => {
    const styles = {
        container: {
            marginStart: gap
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
